import { DEFAULT_SHIPPING_CODE } from "./types"

/**
 * Normalize a shipping method code from CMS, session, or GraphQL.
 * Empty / missing → `""`.
 */
export function normalizeShippingCode(value: unknown): string {
  if (value == null) return ""
  const raw = String(value).trim().toLowerCase()
  if (!raw) return ""
  if (raw === "real_express" || raw === "realexpress") return "real-express"
  // if (raw === "pick_up") return "pickup"
  return raw
}

/** Urban methods that share address state: standard, express, night. */
export function isUrbanCode(code: string): boolean {
  const normalized = normalizeShippingCode(code)
  return (
    normalized === "standard" ||
    normalized === "express" ||
    normalized === "night"
  )
}

/** Every method except standard requires a delivery address. */
export function requiresAddress(code: string): boolean {
  return normalizeShippingCode(code) !== DEFAULT_SHIPPING_CODE
}
